var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardtick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/clipboardtick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7623 2H7.23732C6.45732 2 5.81982 2.63 5.81982 3.41V4.115C5.81982 4.895 6.44982 5.525 7.22982 5.525H10.7623C11.5423 5.525 12.1723 4.895 12.1723 4.115V3.41C12.1798 2.63 11.5423 2 10.7623 2Z",
    fill: "#2E4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9298 4.11511C12.9298 5.30761 11.9548 6.28261 10.7623 6.28261H7.23729C6.04479 6.28261 5.06979 5.30761 5.06979 4.11511C5.06979 3.69511 4.61979 3.43261 4.24479 3.62761C3.7076 3.91367 3.25838 4.34051 2.94525 4.86239C2.63213 5.38426 2.4669 5.9815 2.46729 6.59011V13.6476C2.46729 15.4926 3.97479 17.0001 5.81979 17.0001H12.1798C14.0248 17.0001 15.5323 15.4926 15.5323 13.6476V6.59011C15.5323 5.30761 14.8123 4.19011 13.7548 3.62761C13.3798 3.43261 12.9298 3.69511 12.9298 4.11511ZM11.5048 10.0476L8.50479 13.0476C8.39229 13.1601 8.24979 13.2126 8.10729 13.2126C7.96479 13.2126 7.82229 13.1601 7.70979 13.0476L6.58479 11.9226C6.48018 11.8168 6.42151 11.6739 6.42151 11.5251C6.42151 11.3763 6.48018 11.2335 6.58479 11.1276C6.80229 10.9101 7.16229 10.9101 7.37979 11.1276L8.10729 11.8551L10.7098 9.25261C10.9273 9.03511 11.2873 9.03511 11.5048 9.25261C11.7223 9.47011 11.7223 9.83011 11.5048 10.0476Z",
    fill: "#2E4347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardtick);
export default __webpack_public_path__ + "static/media/clipboardtick.0bc7347ce8dce7ef0f733387e11da302.svg";
export { ForwardRef as ReactComponent };